export const MODAL_NAME = 'payment'
export const MODAL_ACTION_PURCHASE_STARTED = 'purchaseStarted'
export const MODAL_ACTION_PURCHASE_ERROR = 'purchaseError'
export const MODAL_ACTION_PURCHASE_CLOSE = 'purchaseClose'
export const MODAL_ACTION_PURCHASE_SUCCESS = 'purchaseSuccess'

export const MODAL_POPUP_TYPE = 'buy_coins'

export const PAYMENT_ERROR_UNKOWN = 'Unknown error'
